<template>
  <div class="modal-next-button">
    <button @click="$emit('next')" :disabled="disabled">
      <div v-if="loading" class="lds-ripple">
        <div></div>
        <div></div>
      </div>
      <template v-else>{{ label }}</template>
    </button>

  <!--      <div @click="$emit('back')" class="modal-back-button">
      {{ $t("חזור לעמוד הקודם") }}
    </div>-->
  </div>
</template>

<script>
import { $t } from "../../i18n";

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: $t("המשך"),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-next-button {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  position: relative;

  @media screen and (max-width: 991px) {
    padding: 0 20px;
  }

  .lds-ripple {
    // margin: -20px -25px -25px -25px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -53%) scale(0.7);
  }

  button {
    border-radius: 25px;
    background-color: #1d1647;
    font-size: 19px;
    font-weight: bold;
    padding: 14px 30px;
    flex-grow: 1;
    flex-basis: 47px;
    max-width: 372px;
    margin: 44px 0 25px 0;
    height: 66px;
    width: 100%;

    @media screen and (max-width: 991px) {
      margin: 25px 0 25px 0;
    }
  }

  .modal-back-button {
    font-size: 18.2px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 18px;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
